/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { User } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface UserServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Create User
     * This endpoint is used to create a new user. This can only be done by the logged-in user.
     * @param user User object to be created
     */
    createUser(user: User, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Delete User by Username
     * Delete the user with the specified username. This can only be done by the logged-in user.
     * @param username The username of the user to delete.
     */
    deleteUserByUsername(username: string, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Get Start Page
     * Returns the start page for the currently authenticated user.
     */
    getStartPage(extraHttpRequestParams?: any): Observable<string>;

    /**
     * Get User by Username
     * Returns the user with the specified username.
     * @param username The username of the user to fetch.
     */
    getUserByUsername(username: string, extraHttpRequestParams?: any): Observable<User>;

    /**
     * Get Users
     * Returns a list of users.
     */
    getUsers(extraHttpRequestParams?: any): Observable<Array<User>>;

    /**
     * Update User by Username
     * Update the user with the specified username. This can only be done by the logged-in user.
     * @param username The username of the user to update.
     * @param user Updated user object
     */
    updateUserByUsername(username: string, user: User, extraHttpRequestParams?: any): Observable<{}>;

}
